import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ReservationCard from "../../components/Reservation/ReservationCard";
import { t } from "@lingui/macro";

const ReservationCheckPage = () => {
  const location = useLocation();
  const [reservation, setReservation] = useState(location.state?.reservation || null);

  const updateReservation = (updatedData) => {
    setReservation(updatedData);
  };

  if (!reservation) {
    return (
      <p className="text-center text-red-500">
        {t`No reservation data available.`}
      </p>
    );
  }

  return (
    <div className="reservation-check-page">
      <h1 className="text-2xl font-bold">
        {t`Reservation Details`}
      </h1>
      <ReservationCard
        reservation={reservation}
        updateReservation={updateReservation}
      />
    </div>
  );
};

export default ReservationCheckPage;
